(function () {
  console.log("Im in the function"); // Initial log
  const EAGER = true;

  function isTouchDevice() {
    console.log("Checking if device is touch");
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  const isTouch = isTouchDevice();
  console.log("Is touch device:", isTouch);

  const CACHE = {};
  const addToCache = (key) => (value) => {
    console.log(`Adding ${key} to cache with value:`, value);
    CACHE[key] = value;
    return value;
  };

  function getColorCount(skuId) {
    console.log("Fetching color count for SKU:", skuId); // Add this line for debugging
    if (CACHE[skuId] != null) {
      let existing = CACHE[skuId];
      return existing instanceof Promise ? existing : Promise.resolve(existing);
    }

    let p = fetch(
      "https://www.numero74.com/search?q=" +
        skuId +
        "*&type=product&view=siblings-count"
    )
      .then((r) => r.text())
      .then(Number)
      .then(addToCache(skuId));

    CACHE[skuId] = p;
    return p;
  }

  function addColorToProductCard(card, count) {
    console.log("Adding color count to product card:", card, count);
    card.setAttribute("data-color-count", count);
    const caption = card.querySelector(".product-item__title");
    const colorCountEl = document.createElement("div");
    colorCountEl.className = "product-item__color-count";

    colorCountEl.textContent = `Available in ${count} color${
      count === 1 ? "" : "s"
    }`;
    caption.appendChild(colorCountEl);
  }

  console.log("Adding color count listeners"); // Add this log
  function addColorCountListeners() {
    const itemsSelector =
      ".product-item .product-item__link[data-sku-id]:not([data-color-count])";
    const items = document.querySelectorAll(itemsSelector);
    console.log(`Found ${items.length} items matching the selector`); // Add this log

    items.forEach((item) => {
      console.log("Processing item:", item); // Log the individual item

      item.setAttribute("data-color-count", "");

      const skuId = item.getAttribute("data-sku-id");
      console.log("SKU ID:", skuId); // Log the SKU ID

      if (!skuId) {
        return;
      }

      const eventName = isTouch ? "touchstart" : "mouseover";
      const handleListener = (_) => {
        console.log("Event triggered for SKU:", skuId); // Add this log
        getColorCount(skuId).then((count) => {
          addColorToProductCard(item, count);
        });
      };

      if (!EAGER) {
        item.addEventListener(eventName, handleListener, { once: true });
      } else {
        handleListener();
      }
    });
  }

  addColorCountListeners();

  document.addEventListener("after_infinite_product_load", (_) => {
    console.log("Infinite product load triggered");
    addColorCountListeners();
  });
  document.addEventListener("afterProductFilter", (e) => {
    console.log("Product filter applied");
    addColorCountListeners();
  });
})();

(() => {
  class ReadMoreableText extends HTMLElement {
    constructor() {
      super();

      this.onReadMoreClickListener = this.onReadMoreClick.bind(this);
    }

    get expanded() {
      return this.getAttribute("aria-expanded") === "true";
    }
    set expanded(bool) {
      return this.setAttribute("aria-expanded", String(!!bool));
    }

    connectedCallback() {
      this.removeAttribute("x-dehydrated");

      this._content = this.querySelector(
        `.${ReadMoreableText.classes.content}`
      );
      if (!this.showReadMoreButton()) {
        this.classList.add(ReadMoreableText.classes.disable);
        this.classList.remove(ReadMoreableText.classes.unclampable);
        return;
      }

      let height = this.getHeight();
      this.style.setProperty("--element-height", `${height.clamped}px`);
      this.style.setProperty(
        "--max-height-duration",
        `${Math.floor(height.full / 2)}ms`
      );

      this.classList.remove(ReadMoreableText.classes.clamped);

      this.readMores = Array.from(this.querySelectorAll("[data-read-more]"));

      this.readMores.forEach((readMoreBtn) => {
        readMoreBtn.addEventListener("click", this.onReadMoreClickListener);
      });
    }

    disconnectedCallback() {
      this.readMores?.forEach((readMoreBtn) => {
        readMoreBtn.removeEventListener("click", this.onReadMoreClickListener);
      });
    }

    onReadMoreClick(e) {
      const canExpand =
        e.currentTarget.getAttribute("data-read-more") === "true";
      const canRetract =
        !canExpand &&
        e.currentTarget.getAttribute("data-read-more") === "false";

      const height = this.getHeight();

      // console.log('CLICK', { canExpand, canRetract }, e.target)
      this.style.setProperty(
        "--element-height",
        (canExpand ? height.full : height.clamped) + "px"
      );
      this.expanded = canExpand;
      if (canRetract) {
        // requestAnimationFrame(() => {
        //   this.scrollIntoView({ block: 'start' })
        // })
      }
    }

    showReadMoreButton() {
      const sh = this._content.scrollHeight - 4;
      const oh = this._content.offsetHeight;

      return oh < sh;
    }

    get fullHeight() {
      return this.expanded
        ? this.clientHeight
        : this.clientHeight + this._content.scrollHeight;
    }

    getHeight() {
      if (this._height) {
        this._height.full = this.fullHeight;
        return this._height;
      }

      // Get clampped height only once
      let clampedHeight = this._content.clientHeight;
      if (!this.classList.contains(ReadMoreableText.classes.clamped)) {
        this.classList.add(ReadMoreableText.classes.clamped);
        clampedHeight = this._content.clientHeight;
        this.classList.remove(ReadMoreableText.classes.clamped);
      }

      this._height = { clamped: clampedHeight, full: this.fullHeight };
      return this._height;
    }
  }

  ReadMoreableText.classes = {
    content: "Text_Readmoreable__Content",
    clamped: "Text_Readmoreable__ContentClamped",
    unclampable: "Text_Readmoreable__Unclampable",
  };

  if (!window.customElements.get("readmoreable-text")) {
    window.customElements.define("readmoreable-text", ReadMoreableText);
  }
})();
